import { render } from "./navbar.vue?vue&type=template&id=50053a0d&scoped=true&ts=true"
import script from "./navbar.vue?vue&type=script&lang=ts"
export * from "./navbar.vue?vue&type=script&lang=ts"

import "./navbar.vue?vue&type=style&index=0&id=50053a0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50053a0d"]])

export default __exports__